import { Component } from "@angular/core";

@Component({
  selector: "app-paymentrequest-new",
  templateUrl: "./paymentrequest-new.component.html",
  styleUrls: ["./paymentrequest-new.component.less"],
})
export class PaymentrequestNewComponent {}
